// import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";
import { Shop } from "../model/ShopSuccessResponse";

export const GET_SHOP_SUCCESS = "SHOP:GET_SHOP_SUCCESS";

export const getShopSuccessAction = (
  organization: OrganizationKeyName,
  id: string,
  data: Shop
) => ({
  type: GET_SHOP_SUCCESS as typeof GET_SHOP_SUCCESS,
  organization,
  id,
  data,
});

export type GetShopSuccessAction = ReturnType<typeof getShopSuccessAction>;
